import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { H3 } from "commons";

export function Accordion({ children, isOpen = false, handleChange = () => {}, title = "" }) {
    return (
        <AccordionContainer>
            <MuiAccordion square elevation={0} expanded={isOpen} onChange={handleChange}>
                <AccordionSummary
                    data-testid={`${title.toLowerCase().replaceAll(" ", "-")}-accordion`}
                    expandIcon={<ExpandMore />}
                >
                    <TitleContainer>
                        <TitleH3 secondary textAlign="center">
                            {title}
                        </TitleH3>
                    </TitleContainer>
                </AccordionSummary>
                <AccordionDetails>{children}</AccordionDetails>
            </MuiAccordion>
        </AccordionContainer>
    );
}

const TitleH3 = styled(H3)`
    margin: 0;
`;

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
`;

const AccordionContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    && {
        .MuiPaper-root {
            margin-top: 0;
            width: 100%;
        }

        .MuiAccordion-root:before {
            background-color: transparent;
        }

        .MuiAccordionDetails-root {
            padding: 0;
        }
    }
`;

Accordion.propTypes = {
    isOpen: PropTypes.bool,
    handleChange: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]).isRequired
};
